/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PharmacyAddressRequest } from "./PharmacyAddressRequest";

export interface PreferredPharmacyRequest {
  /** Dosespot pharmacy identifier */
  id: string;
  /** Pharmacy name */
  name: string;
  /** Pharmacy address */
  address: PharmacyAddressRequest;
  /** Primary phone number */
  phone: string;
}
